import { useQuery } from 'react-query'
import { useOtoscopyService } from '../services'
import { defaultQueryOptions } from 'constants/'
import { logFactory } from 'utils'
import { QueryOptions } from 'types'

const hookName = 'useCustomerImages'
const log = logFactory(hookName)

const useOtoscopyAssessment = (otoscopyId: string, options: QueryOptions = {}) => {
  const { getOtoscopiesAssessments } = useOtoscopyService()
  const params = { otoscopyId }

  const doQuery = async () => {
    log(`📸 Fetching otoscopy assessment...`, params)

    const {
      data: [assessment],
    } = await getOtoscopiesAssessments(params)

    log(`📸 Found otoscopy assessment...`, assessment)

    return assessment
  }

  return useQuery([hookName, otoscopyId], doQuery, {
    ...defaultQueryOptions,
    refetchOnMount: false,
    ...options,
    enabled: Boolean(otoscopyId),
  })
}

export { useOtoscopyAssessment }
